app.filter("fullDate", function () {
  return function (start) {
    return moment.unix(start).format("LLLL");
  };
});

app.filter("abbrDayOfWeek", function () {
  return function (start) {
    return moment.unix(start).format("ddd");
  };
});

app.filter("hoursAndMins", function () {
  return function (start) {
    return moment.unix(start).format("HH:mm");
  };
});

app.filter("dayAndMonth", function () {
  return function (start) {
    return moment.unix(start).format("DD.MM");
  };
});

app.filter("fromNow", function () {
  return function (start) {
    return moment.unix(start).fromNow().toUpperCase();
  };
});

app.filter("monthAndTime", function () {
  return function (start) {
    return moment.unix(start).format("MMM DD,  hh:mma");
  };
});
